import { render, staticRenderFns } from "./reviewWidgetSummary.vue?vue&type=template&id=3cff9b4c&"
import script from "./reviewWidgetSummary.vue?vue&type=script&lang=js&"
export * from "./reviewWidgetSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vasile_cyt/Documents/plentyDevTool/25996/21/reviewWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cff9b4c')) {
      api.createRecord('3cff9b4c', component.options)
    } else {
      api.reload('3cff9b4c', component.options)
    }
    module.hot.accept("./reviewWidgetSummary.vue?vue&type=template&id=3cff9b4c&", function () {
      api.rerender('3cff9b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/reviewWidgetSummary.vue"
export default component.exports